var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.application
    ? _c(
        "div",
        { staticClass: "application-page" },
        [
          _c(
            "b-container",
            [
              _c("h1", [_vm._v("Sicherheitsprüfung")]),
              _vm._v(" "),
              _c("p", { staticClass: "font-weight-extra-bold color-primary" }, [
                _vm._v(
                  "\n\t\t\tDatenschutz und Anonymität sind für alle Nutzer wichtig.\n\t\t"
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\tFordere einen neuen Zugangscode für deine Mobilnummer an und gib diesen bitte anschließend hier ein.\n\t\t"
                )
              ]),
              _vm._v(" "),
              _vm.success
                ? _c("div", { staticClass: "success mb-3" }, [
                    _vm._v(
                      "\n\t\t\tBestätigung erfolgreich. du wirst in Kürze weitergeleitet.\n\t\t"
                    )
                  ])
                : _c("Resend", {
                    attrs: {
                      type: "mobilePhone",
                      "resend-function": _vm.resendFunction,
                      "change-function": _vm.changeFunction,
                      phone: _vm.application.phone,
                      changable: false
                    },
                    on: { success: _vm.onSuccess }
                  }),
              _vm._v(" "),
              _c("p", { staticClass: "mt-4" }, [
                _vm._v(
                  "\n\t\t\tDiese Prüfung erfolgt, um sicherzugehen, dass ausschließlich du von diesem Zugang aus arbeitest.\n\t\t"
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mt-4" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.logout.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("Abmelden")]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }